export const iOSAppStoreLink = 'https://apps.apple.com/app/id6747361472'

export const androidAppStoreLink = 'https://play.google.com/store/apps/details?id=com.privateai'
